/*
* Handles search functionalities
*/

const searchAndSetResults = (page, sort, filter) => {
    const form = document.getElementById("search-form");
    const inputQ = form.querySelector('input[type="text"][name="q"]');
    const searchButton = document.getElementById("search-button");
    const searchResults = document.getElementById("search-results");
    const spinner = document.getElementById("search-spinner");
    const loadMoreContainer = document.getElementById("search-load-more");
    const loadMoreButton = loadMoreContainer.querySelector('button');

    if (searchButton && loadMoreButton && spinner && inputQ && searchResults) {
        // Disable buttons and show spinner
        searchButton.disabled = true;
        loadMoreButton.disabled = true;
        spinner.classList.remove("hidden");

        // Set the current page
        form.setAttribute("data-current-page", page);

        // Clear results if we are rendering first page
        if (page === 1) {
            searchResults.innerHTML = "";
        }

        let actionUrl = form.action;
        const query = encodeURIComponent(inputQ.value);
        const sortBy = sort ? `&sortType=${sort}` : "";
        const filterBy = filter ? `&${filter}` : "";
        actionUrl = form.action.replace(/\/$/, ""); // Remove trailing slash if present
        const url = `${actionUrl}/SearchGetPartial?q=${query}&p=${page}${sortBy}${filterBy}`;//console.log('url', url)
        fetch(url, {
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(response => response.text())
            .then(html => {
                // Parse the HTML string into a document
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                // Get the root div by ID
                const rootDiv = doc.getElementById('more-items');
                if (rootDiv) {
                    // Get the attributes
                    const moreAvailable = rootDiv.getAttribute('data-more-available');
                    const totalCount = rootDiv.getAttribute('data-total-count');

                    //console.log('Root div:', rootDiv);
                    //console.log('More available:', moreAvailable);
                    //console.log('Total count:', totalCount);

                    // Append all child nodes of rootDiv to searchResults
                    const fragment = document.createDocumentFragment();
                    while (rootDiv.childNodes.length > 0) {
                        fragment.appendChild(rootDiv.childNodes[0]);
                    }
                    searchResults.appendChild(fragment);
                    //searchResults.innerHTML = rootDiv.outerHTML;
                    //searchResults.innerHTML = html;

                    // Update the result text
                    const resultTextEl = document.getElementById("search-result-text");
                    const template = resultTextEl ? resultTextEl.getAttribute("data-template") : "{0} hakutulosta haulle: {1}";
                    if (resultTextEl && template) {
                        resultTextEl.textContent = template.replace("{0}", totalCount).replace("{1}", decodeURIComponent(query));
                        resultTextEl.classList.remove("hidden");
                    }

                    // Show or hide search result sorting
                    const sortEl = document.getElementById("search-result-sort");
                    if (sortEl) {
                        if (totalCount && parseInt(totalCount) > 0) {
                            sortEl.classList.remove("hidden");
                        } else {
                            sortEl.classList.add("hidden");
                        }
                    }

                    // Show or hide load more button
                    if (loadMoreContainer) {
                        if (moreAvailable === "True") {
                            loadMoreContainer.classList.remove("hidden");
                        } else {
                            loadMoreContainer.classList.add("hidden");
                        }
                    }
                }
            })
            .catch(err => {
                console.log('Fetch error:', err);
                searchResults.innerHTML = "<div class='text-red-500'>Search failed.</div>";
            })
            .finally(() => {
                // Re-enable buttons and hide spinner
                searchButton.disabled = false;
                loadMoreButton.disabled = false;
                spinner.classList.add("hidden");
            });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("search-form");
    const sortToggle = document.getElementById("sort-dropdown-toggle");
    if (form) {
        const searchButton = document.getElementById("search-button");
        const loadMoreButton = document.getElementById("load-more-button");

        //if (searchButton) {
        //    searchButton.addEventListener("click", (e) => {
        //        e.preventDefault();
        //        const sortBy = sortToggle ? sortToggle.getAttribute("data-sort") : null;
        //        searchAndSetResults(1, sortBy);
        //    });
        //}

        if (loadMoreButton) {
            loadMoreButton.addEventListener("click", (e) => {
                e.preventDefault();
                const currentPage = parseInt(form.getAttribute("data-current-page") ?? "1", 10);
                //console.log(currentPage, typeof currentPage);
                const sortBy = sortToggle ? sortToggle.getAttribute("data-sort") : null;
                searchAndSetResults(currentPage + 1, sortBy);
            });
        }
    }

    const sortLabel = document.getElementById("sort-dropdown-label");
    const menu = document.getElementById("sort-dropdown-menu");

    if (sortToggle && sortLabel && menu) {
        sortToggle.addEventListener("click", (e) => {
            e.stopPropagation();
            menu.classList.toggle("hidden");
        });

        // Optional: Hide dropdown when clicking outside
        document.addEventListener("click", () => {
            menu.classList.add("hidden");
        });

        // Prevent closing when clicking inside the menu
        menu.addEventListener("click", (e) => {
            e.stopPropagation();
        });

        // Handle sort option click
        menu.querySelectorAll("button[data-sort]").forEach(btn => {
            btn.addEventListener("click", function () {
                const sortType = this.getAttribute("data-sort");
                const sortText = this.textContent.trim();

                // Set the button's text and value
                sortLabel.textContent = sortText;
                sortToggle.setAttribute("data-sort", sortType);

                menu.classList.add("hidden");

                // Call the search method to fetch items sorted
                searchAndSetResults(1, sortType);
            });
        });

        // Handle filtering
        document.querySelectorAll("a[data-filter]").forEach(btn => {
            btn.addEventListener("click", function (e) {
                e.preventDefault(); // Prevent form submission
                const filterType = this.getAttribute("data-filterType");
                const filterValue = this.getAttribute("data-filter"); console.log(`${filterType}=${filterValue}`);
                
                // Call the search method to fetch items sorted
                searchAndSetResults(1, sortToggle.getAttribute("data-sort"), `${filterType}=${filterValue}`);
            });
        });

    }
});